import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "A waveguide is excited by a sound wave of pressure p<sub>1</sub> applied at its input. Go through the images to see how to obtain the analogous electrical circuit at low frequencies.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/04/05/principle/slide-5.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
